import { DataSource, Image, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverInformation extends Layout {
    imageCarrierVerification: Image;
    sourceMovement: DataSource;
    textboxCarrierContact: Textbox;
    textboxCarrierEmail: Textbox;
    textboxCarrierPhone: Textbox;
    textboxOverrideDriver1Nm: Textbox;
    textboxOverrideDriver2Nm: Textbox;
    textboxOverrideDrvr2Cell: Textbox;
    textboxOverrideDrvr2CountryCode: Textbox;
    textboxOverrideDrvr2Email: Textbox;
    textboxOverrideDrvrCell: Textbox;
    textboxOverrideDrvrCountryCode: Textbox;
    textboxOverrideDrvrEmail: Textbox;
}
